import React, { useEffect, useRef, useState } from "react";
import { Checkbox, Form, Input, Modal, Select, Spin } from "antd";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import toast from "react-hot-toast";
import { save } from "../../../../features/save/saveSlice";
import { 
  fetchGender, 
} from "../../../../features/dropdown/dropdownSlice";
import { leaveTypesData } from "../../../../data";

const { TextArea } = Input;

const AddLeaveTypeModal = ({ open, handleCancel, handleFetchData, prodd }) => {
  const [form] = Form.useForm();
  const formRef = useRef(null);
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const { genderData, loading } = useSelector((state) => state.dropdown);
  const { saving } = useSelector((state) => state.save);

  const [formData, setFormData] = useState(prodd);

  const [value, setValue] = useState(prodd?.ltHasgender === 1 ? true : false);

  const onChangeCheck = (e) => {
    setValue(e.target.checked);
  };

  const onChange = async (e) => {
    setFormData((prev) => ({
      ...prev,
      [e.target.name]: e.target.value,
    }));
  };

  async function handleSelectChange(value, formName) {
    await setFormData((prevData) => ({
      ...prevData,
      [formName]: value,
    }));
  }

  const onFinish = async (data) => {
    if (!formData?.ltLvtype) {
      toast.error("Please select system leave type");
      return;
    }
  
    
    const res = await dispatch(
      save({
        ltId: prodd?.ltId ? prodd?.ltId : null,
        ltLvtypename: formData?.ltLvtypename,
        ltLvtypecode: formData?.ltLvtypecode,
        ltLvtype: formData?.ltLvtype,
        ltHasgender:value? 1:null,
        gdId:formData?.gdId, 
        url: "hr/saveLeaveType.action",
      })
    );
    if (res?.payload?.success) {
      await toast.success(res?.payload?.messages?.message);
      await handleFetchData();
      await setFormData({});
      await handleCancel();
      await form.resetFields();
    } else {
      toast.error(res?.payload?.messages?.message);
    }
  };

  async function fetchGenderData() {
    await dispatch(fetchGender());
  }

  useEffect(() => {
    setFormData(prodd);
  }, [prodd]);


  useEffect(() => {
    setValue(prodd?.ltHasgender === 1 ? true : false);
  }, [prodd]);
  return (
    <>
      <Modal
        className="modal-btn mod-height mod-footer"
        title={
          prodd
            ? `Edit leave type ${prodd?.ltLvtypename}`
            : "Add leave type details"
        }
        open={open}
        onOk={onFinish}
        onCancel={handleCancel}
        width={850}
      >
        <Form
          layout="vertical"
          ref={formRef}
          name="control-ref"
          onFinish={onFinish}
          className=" "
          style={{
            maxWidth: "100%",
          }}
          form={form}
        >
         
          <Form.Item
            label="Leave Type Code"
            rules={[
              {
                required: true,
                message: "Enter Leave Type Code",
              },
            ]}
          >
            <Input
              required
              name="ltLvtypecode"
              onChange={onChange}
              value={formData?.ltLvtypecode}
              className="input"
            />
          </Form.Item>

          <Form.Item
            label="Leave Type Name"
            rules={[
              {
                required: true,
                message: "Leave Type Name",
              },
            ]}
          >
            <Input
              required
              name="ltLvtypename"
              onChange={onChange}
              value={formData?.ltLvtypename}
              className="input"
            />
          </Form.Item>
          <Form.Item
            className=""
            label={<span>System Leave Type</span>}
            rules={[
              {
                required: true,
                message: "Please select System Leave Type",
              },
            ]}
          >
            <Select
              name="ltLvtype"
              className=""
              allowClear
              style={{
                width: "100%",
              }}
              options={
                leaveTypesData?.length > 0 &&
                leaveTypesData?.map((item) => ({
                  value: item?.value,
                  label: item?.label,
                }))
              }
              onChange={(value) => {
                handleSelectChange(value, "ltLvtype");
              }}
              value={formData?.ltLvtype}
              showSearch
              optionFilterProp="children"
              filterOption={(input, option) =>
                (option?.label?.toLocaleLowerCase() ?? "").includes(
                  input?.toLocaleLowerCase()
                )
              }
              onDropdownVisibleChange={() => { 
              }}
              dropdownRender={(menu) => (
                <>
                  {loading && (
                    <div
                      style={{
                        padding: "8px",
                        textAlign: "center",
                      }}
                    >
                      <Spin className="sms-spin" />
                    </div>
                  )}
                  {menu}
                </>
              )}
            />
          </Form.Item>

          <Form.Item
             label="Has Gender"
             rules={[
               {
                 required: false,
                 message: "check recurrs",
               },
             ]}>
            <Checkbox checked={value} value={value} onChange={onChangeCheck}>
            </Checkbox>
          </Form.Item>

          <Form.Item
              className=""
              label={<span>Gender</span>}
              rules={[
                {
                  required: false,
                  message: "Please select gender",
                },
              ]}
            >
              <Select
                name="gdId"
                className=""
                allowClear
                style={{
                  width: "100%",
                }}
                options={
                  genderData?.length > 0 &&
                  genderData?.map((item) => ({
                    value: item?.gdId,
                    label: item?.gdName,
                  }))
                }
                onChange={(value) => {
                  handleSelectChange(value, "gdId");
                }}
                value={formData?.gdId}
                showSearch
                optionFilterProp="children"
                filterOption={(input, option) =>
                  (option?.label?.toLocaleLowerCase() ?? "").includes(
                    input?.toLocaleLowerCase()
                  )
                }
                onDropdownVisibleChange={() => {
                  fetchGenderData();
                }}
                dropdownRender={(menu) => (
                  <>
                    {loading && (
                      <div
                        style={{
                          padding: "8px",
                          textAlign: "center",
                        }}
                      >
                        <Spin className="sms-spin" />
                      </div>
                    )}
                    {menu}
                  </>
                )}
              />
            </Form.Item>

          <div className="flex lg:flex-row flex-col justify-between mt-[56px] mb-[48px]">
            <div className="justify-start"></div>
            <div className="justify-end flex items-center gap-x-2">
              <div className="w-[200px]">
                <button
                  key="back"
                  type="button"
                  onClick={handleCancel}
                  className="cstm-btn !bg-white !text-lightBlack !border !border-lightBlack"
                >
                  Cancel
                </button>
              </div>

              <div className="w-[200px]">
                <button
                  key="submit"
                  type="submit"
                  className="cstm-btn"
                  disabled={saving}
                >
                  {saving ? <Spin /> : "Create"}
                </button>
              </div>
            </div>
          </div>
        </Form>
      </Modal>
    </>
  );
};
export default AddLeaveTypeModal;
